/* tslint:disable */
/* eslint-disable */
/**
 * Y-sports-Core API
 * API for managing Y-sports related stuff
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TournamentMeta
 */
export interface TournamentMeta {
    /**
     * 
     * @type {string}
     * @memberof TournamentMeta
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentMeta
     */
    creator?: string;
    /**
     * 
     * @type {Date}
     * @memberof TournamentMeta
     */
    creationDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof TournamentMeta
     */
    description?: string;
}

/**
 * Check if a given object implements the TournamentMeta interface.
 */
export function instanceOfTournamentMeta(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TournamentMetaFromJSON(json: any): TournamentMeta {
    return TournamentMetaFromJSONTyped(json, false);
}

export function TournamentMetaFromJSONTyped(json: any, ignoreDiscriminator: boolean): TournamentMeta {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'creator': !exists(json, 'creator') ? undefined : json['creator'],
        'creationDate': !exists(json, 'creationDate') ? undefined : (new Date(json['creationDate'])),
        'description': !exists(json, 'description') ? undefined : json['description'],
    };
}

export function TournamentMetaToJSON(value?: TournamentMeta | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'creator': value.creator,
        'creationDate': value.creationDate === undefined ? undefined : (value.creationDate.toISOString()),
        'description': value.description,
    };
}

